import React, {Component} from 'react'
import {Button} from 'antd'
import ImportLabelsPDFModal from './ImportLabelsPDFModal'

class ImportLabelsPDFV2 extends Component {
    state = {
        isOpen: false
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render() {
        const {isOpen} = this.state

        return (
            <div className='ImportLabelsPDF'>
                <Button onClick={this._handleToggleModal} type='primary' icon='upload'>
                    Import từ PDF
                </Button>

                <ImportLabelsPDFModal isOpen={isOpen} onClose={this._handleToggleModal}/>
            </div>
        )
    }
}

export default ImportLabelsPDFV2
